import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { getTable } from "../../../../Services/tooltipService";
import DataTable from "../../../../Components/UiComponents/DataTable";
import Loader from "../../../../Components/UiComponents/Loader";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { getUsersTimesheet, getTimesheet, generateUsersTimesheet } from "../../../../Services/opportunityService";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import { getUsersList } from "../../../../Services/userService";
import ExcelUploader from "./ExcelUploader";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";

const UsersTimesheet = (props) => {
    const [loading, setLoading] = useState(false);
    const [timeSheetTables, setTimeSheetTables] = useState([]);
    const [timeSheetHeadings, setTimeSheetHeadings] = useState([]);
    const [usersTimesheet, setUsersTimesheet] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [oppFilter, setOppFilter] = useState([]);
    const [selectedProject, setSelectedProject] = useState('All');
    const [selectedUser, setSelectedUser] = useState('All');
    const [uploadTimesheet, setUploadTimesheet] = useState(false);
    const navigate = useNavigate()

    var enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const toastRef = useRef();

    useEffect(() => {
        initialgetTables()
        getUsersTimesheets()
        getAllUser()
    }, []);

    const initialgetTables = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var fieldData = await getTable(tmpData.customer)
            if (fieldData && fieldData?.data) {
                var myAccModuleDataTables = fieldData.data;
                var myaccFieldsTable = _.find(myAccModuleDataTables.cust[0].modules, { module_name: "My Account", status: true });
                var timeSheetTables = _.find(myaccFieldsTable.sub_modules, { sub_module_name: "Time Sheet" }).tables;
                setTimeSheetTables(timeSheetTables);
                var timeSheetHeadings = _.find(timeSheetTables, { table_name: "TimeSheet" }).headers;
                setTimeSheetHeadings(timeSheetHeadings);
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getUsersTimesheets = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            var usersTimesheet = await getUsersTimesheet(tmpData.customer, tmpData.branch)
            if (usersTimesheet && usersTimesheet.data) {
                setUsersTimesheet(usersTimesheet.data.opps)
                var oppFilter = _.cloneDeep(usersTimesheet.data.oppFilter);
                oppFilter.unshift({ _id: 'All', opportunity_name: 'All' })
                setOppFilter(oppFilter)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }

    const getAllUser = async () => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var userData = await getUsersList(tmpData.customer, tmpData.branch)
            if (userData && userData.data) {
                var filters = userData.data;
                const userOption = filters.map((user) => ({
                    _id: user._id,
                    firstname: user.firstname,
                    surname: user.surname,
                    username: user.firstname + ' ' + user.surname,
                }));
                userOption.unshift({ _id: 'All', firstname: "All", surname: "", username: "All" });
                setAllUsers(userOption)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const idTemplate = (rowData, index) => {
        return index.rowIndex + 1;
    }

    const columns = [
        {
            field: "id",
            header: _.find(timeSheetHeadings, { header_name: "#" })?.display_name,
            body: idTemplate,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "opportunity_seq",
            header: _.find(timeSheetHeadings, { header_name: "Project Id" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "opportunity_name",
            header: _.find(timeSheetHeadings, { header_name: "Project" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "team_member",
            header: _.find(timeSheetHeadings, { header_name: "Team Member" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "bid_team_role",
            header: _.find(timeSheetHeadings, { header_name: "Bid Team Role" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "total_est_hours",
            header: _.find(timeSheetHeadings, { header_name: "Est Hours" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "total_actual",
            header: _.find(timeSheetHeadings, { header_name: "Actual Hours to Date" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        },
        {
            field: "actual_to_date",
            header: _.find(timeSheetHeadings, { header_name: "Last Updated Date" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: "row-datatable",
        }
    ]

    const resetButton = () => {
        setSelectedProject('All')
        setSelectedUser('All')
        setShowDropdown(false)
        filterTimesheet('All', 'All')
    }

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown)
    }

    const getTimesheetDetails = async (userId, oppId) => {
        try {
            if (tmpData === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var timesheet = [];
            var timesheetData = await getTimesheet(tmpData.customer, userId, oppId)
            if (timesheetData && timesheetData.data) {
                timesheet = timesheetData.data.opps;
                setUsersTimesheet(timesheet)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const filterTimesheet = (value, project) => {
        value != '' ? setSelectedUser(value) : setSelectedUser('All')
        project != '' ? setSelectedProject(project) : setSelectedProject('All')
        if (value == 'All' && project == 'All') {
            getUsersTimesheets();
        } else {
            getTimesheetDetails(value, project);
        }
    }

    const uploadUsersTimesheet = () => {
        setUploadTimesheet(true)
    }

    const onCloseUploadPopup = () => {
        setUploadTimesheet(false);
    };

    const attachedData = (data) => {
        if (data) {
            getUsersTimesheets()
        }
    }

    const generateUsersTimesheets = () => {
        var response = generateUsersTimesheet(tmpData.customer, tmpData.branch, 'users');
    }

    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');

            // Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
            if (
                !dropdownContent.contains(target) &&
                target !== dropdownButton &&
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') && // MultiSelect items
                !target.closest('.p-dropdown-item') // Single select dropdown items
            ) {
                setShowDropdown(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);


    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0 mt-10">
                <div className="col pr-0 d-flex justify-end delete-icon">
                    <ButtonElement type="button" icon="pi pi-filter-slash" className="edit-option-button font-text" onClick={resetButton} />
                    <div className='p-relative ml-10' ref={dropdownRef}>
                        <ButtonElement type="button" className="edit-option-button" icon="pi pi-filter" onClick={toggleDropdown} />
                        {
                            showDropdown && (
                                <>
                                    <div className='s-field'>
                                        <div className='new-field w-100'>
                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                <div className="col-md-5 pl-0">
                                                    <label className="form-label text-left">
                                                        User:
                                                    </label>
                                                </div>
                                                <div className="col pr-0">
                                                    <DropdownElement
                                                        value={allUsers.filter(
                                                            (item) => item._id === selectedUser
                                                        )[0]}
                                                        onChange={(e) => filterTimesheet(e.value._id, selectedProject)}
                                                        options={(allUsers != undefined && allUsers.length > 0) ? allUsers : []}
                                                        optionLabel="username"
                                                        placeholder="-- Please select --"
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                <div className="col-md-5 pl-0">
                                                    <label className="form-label text-left">
                                                        Project:
                                                    </label>
                                                </div>
                                                <div className="col pr-0">
                                                    <DropdownElement
                                                        value={oppFilter.filter(
                                                            (item) => item._id === selectedProject
                                                        )[0]}
                                                        onChange={(e) => filterTimesheet(selectedUser, e.value._id)}
                                                        options={(oppFilter != undefined && oppFilter.length > 0) ? oppFilter : []}
                                                        optionLabel="opportunity_name"
                                                        placeholder="-- Please select --"
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                </div>
            </div>
            <div className="data-submit mt-10">
                {
                    _.find(timeSheetTables, { table_name: "Users TimeSheet" })?.status &&
                    <DataTable
                        value={usersTimesheet}
                        columns={columns}
                        dataSubmitted={true}
                        header={true}
                        headerName={true}
                        headingName={_.find(timeSheetTables, { table_name: "Users TimeSheet" })?.display_name}
                        paginator={true}
                    />
                }
            </div>
            <div className="col pr-0 d-flex justify-end mt-10">
                {/* <ButtonElement label="Import" className="cancel-new-button" onClick={() => uploadUsersTimesheet()} /> */}
                <ButtonElement className="save-button" type="submit" onClick={generateUsersTimesheets} label="Export" />
            </div>
            <Dialog
                header={"Upload File"}
                visible={uploadTimesheet}
                position="top"
                className='width-50vw'
                onHide={onCloseUploadPopup}
                draggable={false}
            >
                <ExcelUploader
                    onCloseUploadPopup={onCloseUploadPopup}
                    customerId={tmpData.customer}
                    attachedData={attachedData}
                />
            </Dialog>
        </div>
    );
}

export default UsersTimesheet;
